package com.islamicmedia.site.pages.isitsafe

import androidx.compose.runtime.Composable
import com.islamicmedia.site.components.PublicReviewPage
import com.varabyte.kobweb.core.Page

/** Public SEO review — "/isitsafe/minecraft". Pulls the REAL cached analysis from PROD. */
@Page("/isitsafe/minecraft")
@Composable
fun MinecraftReviewPage() {
    PublicReviewPage(
        slug = "minecraft",
        blurb = "Is Minecraft OK for Muslim kids? Here's the honest Fitrah Filter breakdown of the game against Islamic values: the concerns, the upsides, and the evidence.",
    )
}
